
<template>
	<div class="brand paddingHeader">
		<img class="brand__top" src='https://static.zc0901.com/dci-web-bran-to-top.png' v-if="btnFlag" @click="backTop" />
		<div class="brand__story" v-if="brandData.brand_txt_1">
			<img class="brand__story__img_bottom" :src="brandData.brand_txt_1.image.top" />
			<div class="brand__story__img__mask"></div>
			<img class="brand__story__img_top" :src="brandData.brand_txt_1.image.middle" />
			<div class="brand__story__title">
				<div>品牌故事 /</div>
				<div>Brand story</div>
			</div>
			<div class="brand__story__title_bottom"></div>
			<div class="brand__story__border"></div>
			<div class="brand__story__desc">
				<div>{{brandData.brand_txt_1.key_value}}</div>
				<div>{{brandData.brand_txt_1.txt[0]}}</div>
				<div>{{brandData.brand_txt_1.txt[1]}}</div>
			</div>
		</div>
		<div class="brand__born" v-if="brandData.brand_txt_2">
			<img class="brand__born__first" :src='brandData.brand_txt_2.image.top' />
			<img class="brand__born__second" :src='brandData.brand_txt_2.image.middle' />
			<img class="brand__born__slogan" src='http://static.zc0901.com/dci-web-brand-style-title.png' />
			<div class="brand__born__title">品牌出身</div>
			<div class="brand__born__title_bottom"></div>
			<div class="brand__born__desc">
				<div v-for="(item,index) in brandData.brand_txt_2.txt" :key="index">{{item}}</div>
			</div>
			<img class="brand__born__bottom_bg" src="https://static.zc0901.com/dci-web-brand-born-bg.png" />
		</div>
		<div class="brand__move" v-if="brandData.brand_txt_3">
			<videoPlayer
				class="video-player-box"
				ref="videoPlayer"
				:options="playerOptions"
			></videoPlayer>
			<div class="brand__move__title">创新之举</div>
			<div class="brand__move__title_bottom"></div>
			<div class="brand__move__desc">
				<div v-for="(item,index) in brandData.brand_txt_3.txt" :key="index">{{item}}</div>
			</div>
		</div>
		<div class="brand__features" v-if="brandData.brand_txt_4">
			<img :src="brandData.brand_txt_4.image.bottom" class="brand__features-bottom" />
			<img :src="brandData.brand_txt_4.image.middle" class="brand__features-middle" />
			<img :src="brandData.brand_txt_4.image.top" class="brand__features-top" />
			<div class="brand__features__title">产品特色</div>
			<div class="brand__features__title_bottom"></div>
			<img class="brand__features__bottom" src='https://static.zc0901.com/dci-web-brand-born-bg-left.png' />
			<div class="brand__features__title_desc">
				<div v-for="(item,index) in brandData.brand_txt_4.txt" :key="index">{{item}}</div>
			</div>
			<img class="brand__features__title_img" src='https://static.zc0901.com/dci-web-brand-features-title.png' />
		</div>
		<foot></foot>
	</div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import foot from "../../components/foot/index";
import "./index.scss";
export default {
	components: {
		videoPlayer,
		foot
	},
	data() {
		return {
			playerOptions: {
				width: "960",
				height: "560",
				autoplay: false,
				muted: true,
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				sources: [
					{
						type: "video/mp4",
						src: "http://vjs.zencdn.net/v/oceans.mp4"
					}
				],
				poster:"https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg"
			},
			btnFlag:false
		};
	},
	computed: {
		...mapState('common',{
			brandData:'brandData'
		})
	},
	async created() {
		let res = await this.get_brandData()
		console.log('打印一下',res)
		this.playerOptions.sources[0].src =  res.data.brand_txt_3.link
		this.playerOptions.poster = res.data.brand_txt_3.image.top
	},
	mounted() {
		window.addEventListener('scroll', this.scrollToTop)
	},
	destroyed () {
		window.removeEventListener('scroll', this.scrollToTop)
	},
	methods: {
		...mapActions({
			get_brandData:'common/BRANDDATA'
		}),
		
		backTop () {
			const that = this
			let timer = setInterval(() => {
				let ispeed = Math.floor(-that.scrollTop / 5)
				document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
				if (that.scrollTop === 0) {
					clearInterval(timer)
				}
			}, 16)
		},
		scrollToTop () {
			const that = this
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			that.scrollTop = scrollTop
			if (that.scrollTop > 0) {
				that.btnFlag = true
			} else {
				that.btnFlag = false
			}
		}	
	}
};
</script>
<style lang="scss">

.video-js .vjs-big-play-button {
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
}
.video-player button,
.video-player video {
  outline: none !important;
}
</style>
